@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  width: 100%;
  height: 100%;
  @include ui-sm-text;
}

.header {
  margin-bottom: 58px;
}

.profileImageInner {
  width: 100%;
  height: 100%;
}

.content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
